module.exports = __webpack_public_path__ + "img/how-to-become-a-pharmacist-in-South-Africa.0e8e2add.png";